import { useTranslation } from 'react-i18next'
import { getCurrentSeason, getRegistrationYear } from '../utils/seasonUtils'

/**
 * Hook personnalisé pour gérer les traductions avec variables de saison dynamiques
 */
export function useSeasonalTranslation() {
    const { t } = useTranslation()

    const currentSeason = getCurrentSeason()
    const registrationYear = getRegistrationYear()

    /**
     * Fonction de traduction avec remplacement des variables de saison
     * @param key Clé de traduction
     * @param options Options supplémentaires pour la traduction
     * @returns Texte traduit avec variables de saison remplacées
     */
    const tWithSeason = (key: string, options?: any): string => {
        const translation = t(key, options)

        // S'assurer que translation est une chaîne de caractères
        const translationString = typeof translation === 'string' ? translation : String(translation)

        // Remplacer les placeholders {{season}} et {{registrationYear}}
        return translationString
            .replace(/\{\{season\}\}/g, currentSeason)
            .replace(/\{\{registrationYear\}\}/g, registrationYear.toString())
    }

    return {
        t: tWithSeason,
        currentSeason,
        registrationYear,
    }
}
